<template>
  <div>
    <div
      v-for="(content, index) in data"
      :key="index"
      class="pre-accordion-image"
    >
      <div
        v-if="(content.type === 'textRight' || content.type === 'right') && !isMobile"
        v-dompurify-html="content.text"
        :class="['description', content.type, isFullWidth(content)]"
      />

      <div
        v-if="content.enableVideo"
        class="video-wrapper"
      >
        <iframe
          v-if="$_WebHelpers_supportshH264BaselineVideo()"
          class="top-video"
          type="text/html"
          height="360"
          :src="content.video.source"
        />

        <img
          v-else
          class="top-video"
          :src="content.video.poster"
          :alt="content.video.alt"
        />
      </div>

      <template v-else>
        <a
          v-if="isLinkSet(content.link)"
          class="image-wrap-link"
          :href="getLinkHref(content.link)"
          :target="getLinkTarget(content)"
        >
          <img
            v-if="isVisibleOnDesktop(content)"
            :src="getSource(content.desktop)"
            :alt="getAlt(content.desktop)"
          />

          <img
            v-else-if="isVisibleOnMobile(content)"
            :src="getSource(content.mobile)"
            :alt="getAlt(content.mobile)"
          />
        </a>

        <img
          v-if="!isLinkSet(content.link) && isVisibleOnDesktop(content)"
          :src="getSource(content.desktop)"
          :alt="getAlt(content.desktop)"
        />

        <img
          v-else-if="!isLinkSet(content.link) && isVisibleOnMobile(content)"
          :src="getSource(content.mobile)"
          :alt="getAlt(content.mobile)"
        />

        <div
          v-if="content.type === 'textLeft' || content.type === 'left' || isMobile"
          v-dompurify-html="content.text"
          :class="['description', content.type, isFullWidth(content)]"
        />
      </template>
    </div>
  </div>
</template>

<script>
  import has from 'lodash-es/has'
  import isEmpty from 'lodash-es/isEmpty'
  import { mapGetters } from 'vuex'
  import WebHelpers from 'utils/mixins/WebHelpers'

  export default {
    mixins: [WebHelpers],
    props: {
      data: {
        type: Array,
        required: true
      }
    },
    computed: {
      ...mapGetters('device', ['isMobile', 'isDesktop']),
      playerHeight() {
        return this.isMobile ? 200 : 360
      }
    },
    methods: {
      isVisibleOnDesktop(item) {
        return this.isDesktop && !isEmpty(item.desktop)
      },
      isVisibleOnMobile(item) {
        return !this.isDesktop && !isEmpty(item.mobile)
      },
      isFullWidth(item) {
        if (this.isDesktop && item.desktop === '') {
          return 'full'
        } else if (!this.isDesktop && item.mobile === '') {
          return 'full'
        }

        return ''
      },
      getSource(item) {
        return has(item, 'source') ? item.source : item
      },
      getAlt(item) {
        return has(item, 'alt') ? item.alt : item
      },
      isLinkSet(link) {
        if (has(link, 'href')) {
          return !isEmpty(link.href)
        }
        return !isEmpty(link)
      },
      getLinkHref(link) {
        return has(link, 'href') ? link.href : link
      },
      getLinkTarget(content) {
        return has(content, 'link.target') ? content.link.target : content.linkTarget
      }
    }
  }
</script>

<style
  lang="scss"
  scoped
  rel="stylesheet/scss"
>
  @import '~assets/styles/common.scss';

  .pre-accordion-image {
    margin-bottom: 26px;

    @include bp-mf-tablet {
      display: flex;
    }

    ::v-deep img {
      width: content;
      margin-bottom: 10px;
      align-self: baseline;
      max-width: 100%;

      @include bp-mf-tablet {
        max-width: max-content;
        min-width: min-content;
      }
    }

    .top-video,
    .video-wrapper {
      width: 100%;
    }

    .image-wrap-link {
      img {
        @include bp-mf-tablet {
          width: 100%;
          max-width: unset;
          min-width: unset;
        }
      }
    }

    .description {
      @include bp-mf-tablet {
        margin-left: 35px;

        &.right,
        &.textRight {
          margin: 0 35px 0 0;

          &.full {
            margin: 0;
            width: 100%;
          }
        }

        &.left,
        &.textLeft {
          &.full {
            margin: 0;
            width: 100%;
          }
        }
      }

      ::v-deep p {
        @include body16Style();

        h3 {
          @include h3Style();
        }

        a:not(.js-inline-button) {
          color: $blue-medium;

          &:hover {
            color: $blue-light;
          }
        }
      }

      ::v-deep strong {
        font-weight: 500;
      }

      ::v-deep li {
        position: relative;
        padding-left: 35px;
        @include body16Style();

        @include bp-tablet {
          padding-left: 22px;
        }

        &:not(:last-child) {
          margin-bottom: 8px;

          @include bp-tablet-only {
            margin-bottom: 7px;
          }

          @include bp-mobile {
            margin-bottom: 9px;
          }
        }

        &:before {
          content: '';
          display: block;
          position: absolute;
          top: 8px;
          left: 0;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: $green-base;
        }
      }
    }
  }
</style>
